<template>
  <i-select
    :value="value"
    @on-change="updateValue"
    :filterable="filterable"
    :multiple="multiple"
    remote
    :remote-method="load"
  >
    <i-option v-for="option in options" :key="option.id" :value="option.id">{{
      option.name
    }}</i-option>
  </i-select>
</template>

<script>
import axios from "axios";
import { getTsQueryValue } from "@/utils/common";

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      events: this.value,
      options: [],
    };
  },
  methods: {
    updateValue(value) {
      this.events = value;
      this.$emit("input", value);
      this.$emit("on-change", value);
    },
    load(name) {
      if (name === "" || name.length < 3) return;
      let query = getTsQueryValue(name);
      axios
        .get("/psql/events", {
          params: {
            select: "id,name",
            name: query,
            limit: 48,
          },
        })
        .then(response => {
          this.options = response.data;
        })
        .catch(error => {
          console.error(error.response);
        });
    },
  },
};
</script>

<style lang="css"></style>
